import { Button, Box } from "@mui/material";
import { settingsMessages } from "../features/Settings/messages";
import { useMsg } from "./Msg/Msg";
import { Icon } from "./Icon";

export const ExternalLink = ({ href, children, sx, withEndIcon, ...props }) => {
  if (!href) return null;

  return (
    <Button
      type="button"
      variant="text"
      sx={sx}
      href={href}
      endIcon={
        withEndIcon && (
          <Icon name="OpenInNew" sx={{ fontSize: "inherit" || 14 }} />
        )
      }
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </Button>
  );
};

export const LinkedInProfileMaybe = ({ href }) => {
  const msg = useMsg({ dict: settingsMessages });

  return (
    <Box sx={{ m: 1 }}>
      <ExternalLink
        href={href}
        startIcon={<Icon name="LinkedIn" sx={{ fontSize: 18 }} />}
      >
        {msg("settings.profile.field.linkedinProfile")}
        &nbsp;
        <Icon name="OpenInNew" sx={{ fontSize: "inherit" || 14 }} />
      </ExternalLink>
    </Box>
  );
};
